import { useState } from 'react';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import gtm from '@/utils/gtm';

const Experience: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Experience');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const time = `第四回ふるさと東京応援祭 in SHIBUYA Christmas
会場:代々木公園・野外ステージ
2025年12月20日（土）─ 25日（木）
平日16：00 ─ 22：00
土日11：00 ─ 22：00`;

    const items = [
        {
            item_title: 'ステップ 1',
            title: '暖かな空間へ',
            desc: '見知らぬグループとペアで、EcoFlowのポータブル電源だけで電力を賄っているテントの中に入りましょう。屋外なのにあたたかい、不思議な体験ができます。',
        },
        {
            item_title: 'ステップ 2',
            title: '見知らぬ人との短いワークショップ',
            desc: '暖かなテントの中で短い動画を観て、感じたことをシェアするだけ。\n普段ならすれ違うだけの誰かと、思いがけず心が通い合う時間になるかもしれません。',
        },
        {
            item_title: 'ステップ 3',
            title: '最後に小さなギフトをプレゼント',
            desc: '体験の余韻とともに、小さなギフトをお渡しします。 \nここで知り合った人と少し話をするも良し、帰りながら少し思い返すも良いかもしれません。',
        },
    ];

    const modalContent = `年末が近づくと、ふと胸の奥がざわつく瞬間がある。
でも、忙しさや距離のせいで、実家に帰れない理由もある。
だけど——本当は、帰りたい。
そしてなにより両親が心配。

そんな気持ちを持つ人ほど
「大丈夫だよ」と笑う両親の声を
もう素直に信じきれない年齢になっているのではないでしょうか。

だからこそ私たちは、ただの製品展示ではなく、
「あの人を想う気持ちを、そっと照らす場所」
を作りたいと思いました。

このイベントが
「ちょっとだけ立ち止まって、大切な人を思い返す」
きっかけになったら嬉しい。

そして帰省する人も、帰れない人も、
「安心だけでも、先に届けられる」
そう思える冬になりますように。

家族を想う気持ちが、行動につながる冬にしたい。
そのきっかけを、街の真ん中でつくりました。
    `;

    function handleClick() {
        setIsModalOpen(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: '企画の想い',
            page_name: 'furusato-tokyo-support-festival',

            __btn_id1: 'experience-btn',
            __btn_id2: 'experience-btn',
            __btn_type: 'common',
        });
    }

    return (
        <div className={styles.Experience + ' experience GtmModuleData-section'} data-section-id="experience">
            <div className="lp-layout">
                <div className="label">「身体だけではなく、心から温まる」</div>
                <div className="title">体験イベントを開催</div>

                <div className="line"></div>

                <div className="btn GtmModuleData-btn-common experience-btn" data-btn-id="experience-btn" onClick={() => handleClick()}>
                    企画の想い
                </div>

                {isModalOpen && (
                    <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            {/* <div className="modal-header">
                                <div className="modal-title">企画の想い</div>
                                <div className="modal-close" onClick={() => setIsModalOpen(false)}>
                                    ×
                                </div>
                            </div> */}
                            <div className="modal-body">
                                <div className="modal-body-text">{modalContent}</div>
                                <div className="modal-body-img">
                                    <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1765185058884-dfvezk-compressed-%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88%202025-11-25%2013.40.53%201.jpg" />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="time">{time}</div>

                <div className="data">入場無料*</div>
                <div className="notice">*12/24・25の18：00以降はクリスマスを共に過ごす人がいない方のみ参加・体験できます。</div>

                <div className="box">
                    <div className="box-left">
                        {items.map((item) => (
                            <div className="item" key={item.item_title}>
                                <div className="item-index">{item.item_title}</div>
                                <div className="item-content">
                                    <div className="item-title">{item.title}</div>
                                    <div className="item-desc">{item.desc}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="box-right">
                        <EcoImg pc="https://websiteoss.ecoflow.com/figma-uploads/1764749719257-im1xsl-compressed-_%E3%83%AC%E3%82%A4%E3%83%A4%E3%83%BC_1.png" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Experience;
